/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://du3dneju4zcnnmciiihy4pheqy.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-au6jr4yoivbsbjtj5jcyelxf2y",
    "aws_cognito_identity_pool_id": "ap-south-1:eab6f471-d7cc-42b2-81b4-ff7ea1656ee1",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_ONoK629ss",
    "aws_user_pools_web_client_id": "57fhgchiqen9so3ui8a5epo01u",
    "oauth": {
        "domain": "hypecircle-prod-temp-prod.auth.ap-south-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://www.hypecircle.co.in/",
        "redirectSignOut": "https://www.hypecircle.co.in/,http://localhost:3000/,https://www.hypecircle.co.in/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "devbucket96ac4-prod",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
